export default {
  BLEACH: {
    ANY: {
      text: 'Any bleach allowed',
      icon: '&#xe000;',
    },
    NON_CHLORINE: {
      text: 'Non-chlorine beach only',
      icon: '&#xe001;',
    },
    NONE: {
      text: 'Do not bleach',
      icon: '&#xe002;',
    },
  },
  DRY_CLEAN_SOLVENT: {
    NONE: {
      text: 'Do not dry clean',
      icon: '&#xe00a;',
    },
    NORMAL: {
      text: 'Can be dry cleaned',
      icon: '&#xe007;',
    },
    NON_TETRA: {
      text: 'Dry clean with any solvent except trichloroethylene',
      icon: '&#xe048;',
    },
    PETRO: {
      text: 'Dry clean using only petroleum solvent',
      icon: '&#xe005;',
    },
    ANY: {
      text: 'Dry clean with any solvent',
      icon: '&#xe006;',
    },
    OPTION_LOW_HEAT: {
      text: 'Dry clean, low heat',
      icon: '&#xe042;',
    },
    OPTION_NO_STEAM: {
      text: 'Dry clean, no steam',
      icon: '&#xe044;',
    },
    OPTION_REDUCED_MOISTURE: {
      text: 'Dry clean, reduced moisture',
      icon: '&#xe04c;',
    },
    OPTION_SHORT_CYCLE: {
      text: 'Dry clean, short cycle',
      icon: '&#xe04e;',
    },
  },
  DRYING: {
    NONE: {
      text: 'Do not dry',
      icon: '&#xe04f;',
    },
    SHADE: {
      text: 'Dry away from direct sunlight',
      icon: '&#xe03f;',
    },
    DRIP: {
      text: 'Drip dry',
      icon: '&#xe008;',
    },
    DRIP_SHADE: {
      text: 'Drip dry away from direct sunlight',
      icon: '&#xe040;',
    },
    FLAT: {
      text: 'Dry flat',
      icon: '&#xe03e;',
    },
    FLAT_SHADE: {
      text: 'Dry flat away from direct sunlight',
      icon: '&#xe03d;',
    },
    LINE: {
      text: 'Dry on a line',
      icon: '&#xe03c;',
    },
    LINE_SHADE: {
      text: 'Dry on a line away from direct sunlight',
      icon: '&#xe03b;',
    },
    OPTION_NO_WRING: {
      text: 'Do not wring',
      icon: '&#xe01c;',
    },
  },
  IRONING_TEMP: {
    NONE: {
      text: 'Do not iron',
      icon: '&#xe033;',
    },
    LOW: {
      text: 'Iron at low heat (110°C)',
      icon: '&#xe02d;',
    },
    MEDIUM: {
      text: 'Iron at medium heat (150°C)',
      icon: '&#xe030;',
    },
    HIGH: {
      text: 'Iron at high heat (200°C)',
      icon: '&#xe02a;',
    },
    ANY: {
      text: 'Iron at any temperature, steamed or dry',
      icon: '&#xe027;',
    },
    OPTION_NO_STEAM: {
      text: 'Do not steam with iron',
      icon: '&#xe036;',
    },
  },
  TUMBLE_DRY: {
    NONE: {
      text: 'Do not tumble dry',
      icon: '&#xe024;',
    },
    NO_HEAT: {
      text: 'Tumble dry without heat',
      icon: '&#xe021;',
    },
    LOW_HEAT_NORMAL: {
      text: 'Tumble dry at low heat',
      icon: '&#xe00c;',
    },
    LOW_HEAT_PRESS: {
      text: 'Tumble dry at low heat (permanent press)',
      icon: '&#xe00e;',
    },
    LOW_HEAT_DELICATE: {
      text: 'Tumble dry at low heat (delicate)',
      icon: '&#xe00d;',
    },
    MEDIUM_HEAT_NORMAL: {
      text: 'Tumble dry at medium heat',
      icon: '&#xe00f;',
    },
    MEDIUM_HEAT_PRESS: {
      text: 'Tumble dry at medium heat (permanent press)',
      icon: '&#xe020;',
    },
    HIGH_HEAT_NORMAL: {
      text: 'Tumble dry at high heat',
      icon: '&#xe039;',
    },
    ANY_HEAT_NORMAL: {
      text: 'Tumble dry at any heat',
      icon: '&#xe03a;',
    },
  },
  WASH: {
    NONE: {
      text: 'Do not wash',
      icon: '&#xe01d;',
    },
    NORMAL: {
      text: 'Machine washable',
      icon: '&#xe019;',
    },
    HAND: {
      text: 'Hand wash',
      icon: '&#xe016;',
    },
    HAND_30: {
      text: 'Hand wash at 30°C',
      icon: '&#xe015;',
    },
    HAND_40: {
      text: 'Hand wash at 40°C',
      icon: '&#xe010;',
    },
    TEMP_30_NORMAL: {
      text: 'Wash at 30°C',
      icon: '&#xe018;',
    },
    TEMP_30_PRESS: {
      text: 'Wash at 30°C (permanent press)',
      icon: '&#xe022;',
    },
    TEMP_30_DELICATE: {
      text: 'Wash at 30°C (delicate)',
      icon: '&#xe012;',
    },
    TEMP_40_NORMAL: {
      text: 'Wash at 40°C',
      icon: '&#xe028;',
    },
    TEMP_40_PRESS: {
      text: 'Wash at 40°C (permanent press)',
      icon: '&#xe034;',
    },
    TEMP_40_DELICATE: {
      text: 'Wash at 40°C (delicate)',
      icon: '&#xe02e;',
    },
    TEMP_50_NORMAL: {
      text: 'Wash at 50°C',
      icon: '&#xe01a;',
    },
    TEMP_50_PRESS: {
      text: 'Wash at 50°C (permanent press)',
      icon: '&#xe014;',
    },
    TEMP_60_NORMAL: {
      text: 'Wash at 60°C',
      icon: '&#xe01e;',
    },
    TEMP_60_PRESS: {
      text: 'Wash at 60°C (permanent press)',
      icon: '&#xe026;',
    },
    TEMP_70_NORMAL: {
      text: 'Wash at 70°C',
      icon: '&#xe02c;',
    },
    TEMP_95_NORMAL: {
      text: 'Wash at 95°C',
      icon: '&#xe032;',
    },
    TEMP_95_PRESS: {
      text: 'Wash at 95°C (permanent press)',
      icon: '&#xe038;',
    },
  },
} as {
  [category: string]: {
    [key: string]: {
      text: string;
      icon: string;
    };
  };
};
